import React, { useEffect, useState } from "react";
import { Layout } from "../../containers";
import { Container } from "./styled";
import secureLocalStorage from "react-secure-storage";
import firebase from "../../../lib/fire";
import { calculatePlayerStats, calculatePercj } from "../../../lib/cabbStats";
import { formatDate, unformatDate } from "../../../lib/formatDate";
import { Link } from "react-router-dom";
import { Loader } from "../../../components";
import activeSeasons from "../../../lib/activeSeasons.json";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  Title,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { Radar, Line } from "react-chartjs-2";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Filler,
  Tooltip,
  Legend,
  Title
);

export default function Profile({ appData }) {
  const userLocal = secureLocalStorage.getItem("userLocal");
  const [teamGames, setTeamGames] = useState(null);
  const userLocalId = secureLocalStorage.getItem("userId");
  const [isEditProfileActive, setIsEditProfileActive] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedChart, setSelectedChart] = useState(null);
  const [dataSets, setDataSets] = useState(null);
  const [games, setGames] = useState(null);
  const [form, setForm] = useState({
    name: "",
    plan: "",
    plays: [],
    teamId: "",
    typeOfUser: "",
  });
  const options = {
    responsive: true,
    hover: {
      backgroundColor: "rgba(255, 99, 132, 0.6)",
    },
    scales: {
      r: {
        suggestedMin: 10,
      },
    },
  };
  const optionsLine = {
    responsive: true,
    plugins: {
      title: {
        display: false,
      },
      zoom: {
        pan: {
          enabled: true,
          mode: "xy",
        },
        zoom: {
          wheel: {
            enabled: true,
          },
          pinch: {
            enabled: true,
          },
          mode: "xy",
        },
      },
    },
  };

  useEffect(() => {
    let activeLeague = appData?.teams
      ?.find((item) => item._id === userLocal.teamId)
      ?.history.find(
        (item) => item.season === process.env.REACT_APP_ACTIVE_SEASON
      ).league;

    if (activeLeague !== null) {
      const fetchData = async () => {
        try {
          const response = await fetch(
            `https://deportactico-vercel-serverless.vercel.app/api/gamesByleague?season=${process.env.REACT_APP_ACTIVE_SEASON}&league=${activeLeague}`
          );
          const result = await response.json();
          setTeamGames(result);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
        }
      };

      fetchData();
    }
  }, [appData, userLocal]);

  function updateForm(value) {
    return setForm((prev) => {
      return { ...prev, ...value };
    });
  }

  function calcualtePositions(games) {
    let teamsArr = [];
    appData.teams?.forEach((team) => {
      if (team.league === "LA") {
        teamsArr.push({
          _id: team._id,
          name: team.name,
          gamesWon: 0,
          gamesLost: 0,
          totalPoints: 0,
          pointsMade: 0,
          pointsRecibed: 0,
          league: "LA",
          zone: team.zone === "sur" ? "sur" : "norte",
        });
      } else {
        teamsArr.push({
          _id: team._id,
          name: team.name,
          gamesWon: 0,
          gamesLost: 0,
          totalPoints: 0,
          pointsMade: 0,
          pointsRecibed: 0,
          league: "LNB",
        });
      }
    });

    for (let index = 0; index < games?.length; index++) {
      let localTotalPts = 0;
      let visitTotalPts = 0;
      const localTeam = teamsArr?.find(
        (object) => object._id === games[index].local_team
      );
      games[index].local_stats.forEach((element) => {
        localTotalPts += element.pts;
      });
      const visitTeam = teamsArr?.find(
        (object) => object._id === games[index].visit_team
      );
      games[index].visit_stats.forEach((element) => {
        visitTotalPts += element.pts;
      });

      localTeam.pointsMade += localTotalPts;
      localTeam.pointsRecibed += visitTotalPts;
      visitTeam.pointsMade += visitTotalPts;
      visitTeam.pointsRecibed += localTotalPts;
      if (localTotalPts > visitTotalPts) {
        localTeam.gamesWon++;
        visitTeam.gamesLost++;
      } else {
        localTeam.gamesLost++;
        visitTeam.gamesWon++;
      }
    }
    teamsArr.forEach((element) => {
      element.totalPoints = element.gamesWon * 2 + element.gamesLost;
    });
    return teamsArr;
  }

  useEffect(() => {
    updateForm({
      name: userLocal?.name,
      teamId: userLocal.teamId,
      plan: userLocal.plan,
      typeOfUser: userLocal.typeOfUser,
    });
    setSelectedChart(userLocal.typeOfUser === "Jugador" ? "games" : "players");
    const shootingData = {
      labels: [
        "Procentaje de 3 puntos",
        "Procentaje de 2 puntos",
        "Procentaje de 1 puntos",
        "Procentaje de tiros de campo",
      ],
      datasets: [
        {
          label: userLocal?.name,
          data: [
            calculatePlayerStats(
              teamGames?.filter(
                (game) =>
                  (game.local_team === userLocal?.teamId ||
                    game.visit_team === userLocal?.teamId) &&
                  game.season === process.env.REACT_APP_ACTIVE_SEASON
              ),
              userLocal.id,
              "THREEPP"
            ),
            calculatePlayerStats(
              teamGames?.filter(
                (game) =>
                  (game.local_team === userLocal?.teamId ||
                    game.visit_team === userLocal?.teamId) &&
                  game.season === process.env.REACT_APP_ACTIVE_SEASON
              ),
              userLocal.id,
              "TWOOPP"
            ),
            calculatePlayerStats(
              teamGames?.filter(
                (game) =>
                  (game.local_team === userLocal?.teamId ||
                    game.visit_team === userLocal?.teamId) &&
                  game.season === process.env.REACT_APP_ACTIVE_SEASON
              ),
              userLocal.id,
              "FTP"
            ),
            calculatePlayerStats(
              teamGames?.filter(
                (game) =>
                  (game.local_team === userLocal?.teamId ||
                    game.visit_team === userLocal?.teamId) &&
                  game.season === process.env.REACT_APP_ACTIVE_SEASON
              ),
              userLocal.id,
              "FGP"
            ),
          ],
          backgroundColor: "rgba(255, 99, 132, 0.2)",
          borderColor: "rgba(255, 99, 132, 0.6)",
          borderWidth: 1,
          lineTension: 0.3,
          hoverBackgroundColor: "blue",
        },
      ],
    };

    const startDate = new Date("10/07/2024"); // Set your start date
    const endDate = new Date(); // Set your end date
    const millisecondsPerWeek = 7 * 24 * 60 * 60 * 1000; // Number of milliseconds in a week

    // Calculate the number of weeks between start and end date
    const numberOfWeeks = Math.ceil(
      (endDate - startDate) / millisecondsPerWeek
    );
    const weekDates = [];

    let currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      const startOfWeek = new Date(currentDate);
      startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      weekDates.push({
        start: new Date(startOfWeek),
        end: new Date(endOfWeek),
      });
      currentDate.setDate(currentDate.getDate() + 7);
    }
    if (userLocal.teamId !== "null" && userLocal.teamId !== null) {
      const teamsArr = appData?.teams
        ?.filter(
          (team) =>
            team?.league ===
            appData?.teams?.filter((team) => team._id === userLocal.teamId)[0]
              .league
        )
        .map((team) => ({
          _id: team._id,
          name: team.name,
          gamesWon: 0,
          gamesLost: 0,
          totalPoints: 0,
          pointsMade: 0,
          pointsRecibed: 0,
          zone:
            appData?.teams?.filter((team) => team._id === userLocal.teamId)[0]
              .league === undefined
              ? null
              : team.zone === "sur"
              ? "sur"
              : "norte",
        }));
      const arr = weekDates?.map((week) =>
        calcualtePositions(
          teamGames?.filter(
            (game) =>
              unformatDate(game.date) >=
                unformatDate(formatDate(week.start).DateFormatted) &&
              unformatDate(game.date) <=
                unformatDate(formatDate(week.end).DateFormatted) &&
              game.category ===
                appData?.teams?.filter(
                  (team) => team._id === userLocal.teamId
                )[0].league &&
              game.season === process.env.REACT_APP_ACTIVE_SEASON &&
              game.stage === "Fase regular"
          )
        )
      );

      const arrBKP = [];
      let positions = [0];
      let prevArraySum = {};

      arr.forEach((weekArray) => {
        const currentArraySum = {};
        weekArray.forEach((obj) => {
          const id = obj._id;
          if (prevArraySum[id]) {
            obj.gamesWon += prevArraySum[id].gamesWon;
            obj.gamesLost += prevArraySum[id].gamesLost;
            obj.totalPoints += prevArraySum[id].totalPoints;
          }
          currentArraySum[id] = { ...obj };
        });

        prevArraySum = { ...currentArraySum };
        arrBKP.push(Object.values(currentArraySum));
      });

      arrBKP.forEach((d) => {
        d.sort(
          (a, b) =>
            b.gamesWon / (b.gamesWon + b.gamesLost) -
            a.gamesWon / (a.gamesWon + a.gamesLost)
        );
        const filterdArr =
          appData?.teams?.filter((team) => team._id === userLocal.teamId)[0]
            .league === "LA"
            ? d.filter(
                (team) =>
                  team.zone ===
                  teamsArr.filter((team) => team._id === userLocal.teamId)[0]
                    .zone
              )
            : d.filter(
                (team) =>
                  team.league ===
                  appData?.teams?.filter(
                    (team) => team._id === userLocal.teamId
                  )[0].league
              );

        filterdArr
          .sort((a, b) => b.totalPoints - a.totalPoints)
          .sort(
            (a, b) =>
              b.gamesWon / (b.gamesWon + b.gamesLost) -
              a.gamesWon / (a.gamesWon + a.gamesLost)
          );
        const indexOfObject = filterdArr.findIndex(
          (object) => object._id === userLocal.teamId
        );
        positions.push(indexOfObject + 1);
      });

      setGames(
        arrBKP[arrBKP.length - 1].filter(
          (team) => team._id === userLocal.teamId
        )
      );

      if (
        userLocal.typeOfUser === "owner" ||
        userLocal.typeOfUser === "Entrenador"
      ) {
        setDataSets({
          labels: Array.from({ length: positions.length }, (_, i) => i + 1),
          datasets: [
            {
              label: "Posicion por semanas",
              data: positions,
              fill: false,
              backgroundColor: "rgb(255, 99, 132)",
              borderColor: "rgba(255, 99, 132, 0.2)",
            },
          ],
        });
      } else if (userLocal.typeOfUser === "Jugador") {
        setDataSets(shootingData);
      }
    }
    setIsLoading(false);
  }, [userLocal, appData, teamGames]);

  const handleSaveProfile = () => {
    let userLocalBKP = userLocal;
    setIsLoading(true);
    if (userLocalId !== null && userLocalId !== undefined) {
      var ref = firebase
        .database()
        .ref(`users/0/${userLocalId}`)
        .update({ name: form.name, teamId: form.teamId })
        .then((snapshot) => {
          setIsEditProfileActive(false);
          //UPDATE LOCAL STORAGE
          userLocalBKP.name = form.name;
          userLocalBKP.teamId = form.teamId;
          userLocalBKP.typeOfUser = form.typeOfUser;
          secureLocalStorage.setItem("userLocal", userLocalBKP);
          window.location.reload();
        });
    }
  };

  const editProfile = () => {
    setIsEditProfileActive(true);
  };
  const calculateTeamPosition = () => {
    if (userLocal !== null) {
      let teamsArr = [];
      let teamsSurArr = [];
      let teamsNorteArr = [];
      let activeLeague =
        userLocal.teamId !== "null"
          ? appData?.teams?.filter((team) => team._id === userLocal.teamId)[0]
              .league
          : null;

      appData.teams?.forEach((team) => {
        if (team.league === activeLeague) {
          teamsArr.push({
            _id: team._id,
            name: team.name,
            gamesWon: 0,
            gamesLost: 0,
            totalPoints: 0,
            pointsMade: 0,
            pointsRecibed: 0,
            zone: team.zone === "sur" ? "sur" : "norte",
          });
        }
      });

      for (let index = 0; index < teamGames?.length; index++) {
        if (
          teamGames[index].category === activeLeague &&
          teamGames[index].season === process.env.REACT_APP_ACTIVE_SEASON
        ) {
          let localTotalPts = 0;
          let visitTotalPts = 0;
          const localTeam = teamsArr?.find(
            (object) => object._id === teamGames[index].local_team
          );
          teamGames[index].local_stats.forEach((element) => {
            localTotalPts += element.pts;
          });
          const visitTeam = teamsArr?.find(
            (object) => object._id === teamGames[index].visit_team
          );
          teamGames[index].visit_stats.forEach((element) => {
            visitTotalPts += element.pts;
          });
          localTeam.pointsMade += localTotalPts;
          localTeam.pointsRecibed += visitTotalPts;
          visitTeam.pointsMade += visitTotalPts;
          visitTeam.pointsRecibed += localTotalPts;
          if (localTotalPts > visitTotalPts) {
            localTeam.gamesWon++;
            visitTeam.gamesLost++;
          } else {
            localTeam.gamesLost++;
            visitTeam.gamesWon++;
          }
        }
      }
      teamsArr.forEach((element) => {
        element.totalPoints = element.gamesWon * 2 + element.gamesLost;
      });
      teamsArr.sort(
        (a, b) =>
          b.gamesWon / (b.gamesWon + b.gamesLost) -
          a.gamesWon / (a.gamesWon + a.gamesLost)
      );

      const indexOfObject =
        activeLeague === "LA"
          ? teamsArr
              .filter(
                (e) =>
                  e.zone ===
                  teamsArr.filter((e) => e._id === userLocal.teamId)[0].zone
              )
              .findIndex((object) => {
                return object._id === userLocal.teamId;
              })
          : teamsArr.findIndex((object) => {
              return object._id === userLocal.teamId;
            });
      return indexOfObject;
    }
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <Layout>
      <Container>
        <div className="user-data-header">
          <div className="user-data-header-extra">
            <img className="user-img" src="/assets/user-icon.png" />
            <h1>{userLocal?.name}</h1>
            <div className="flex_center_space-between">
              <img src="/assets/location-icon.svg" className="location-icon" />
              <p>Ubicacion: Argentina</p>
            </div>
          </div>
        </div>
        <div className="user-data-container">
          <div className="container-left">
            <div className="personal-information">
              <div className="flex_center_space-between">
                <h4>Mis datos</h4>
                {isEditProfileActive ? (
                  <>
                    <button
                      className="btn-primary ghost"
                      onClick={(e) => setIsEditProfileActive(false)}
                    >
                      X
                    </button>
                    <button
                      onClick={(e) => handleSaveProfile()}
                      className="btn-primary"
                    >
                      Guardar
                    </button>
                  </>
                ) : (
                  <img
                    className="edit-icon"
                    alt="edit-icon"
                    src="/assets/edit-icon-o.svg"
                    onClick={editProfile}
                  />
                )}
              </div>
              {isEditProfileActive ? (
                <>
                  <div className="user-data-content flex_center_space-between">
                    <p className="title">Nombre</p>
                    <input
                      placeholder={userLocal?.name}
                      onChange={(e) => updateForm({ name: e.target.value })}
                    />
                  </div>
                  <div className="user-data-content flex_center_space-between">
                    <p className="title">Club</p>
                    <select
                      onChange={(e) => updateForm({ teamId: e.target.value })}
                    >
                      {appData?.teams
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((team, i) => (
                          <option value={team._id}>{team.name}</option>
                        ))}
                    </select>
                  </div>
                  <div className="user-data-content flex_center_space-between">
                    <p className="title">Puesto</p>
                    <select
                      onChange={(e) =>
                        updateForm({ typeOfUser: e.target.value })
                      }
                    >
                      <option>Entrenador</option>
                      <option>Jugador</option>
                      <option>Asistente técnico</option>
                      <option>Gerenete de club</option>
                      <option>Scouter</option>
                      <option>Particular</option>
                    </select>
                  </div>
                </>
              ) : (
                <>
                  <div className="user-data-content flex_center_space-between">
                    <p className="title">Nombre</p>
                    {userLocal.typeOfUser === "Jugador" ? (
                      <Link to={`/statsProfile/${userLocal.id}`}>
                        {userLocal?.name}{" "}
                      </Link>
                    ) : (
                      <p className="content">{userLocal?.name}</p>
                    )}
                  </div>
                  <div className="user-data-content flex_center_space-between">
                    <p className="title">Club</p>
                    <Link
                      className="content"
                      to={`/teamProfile/${userLocal.teamId}`}
                    >
                      {userLocal?.teamId &&
                      userLocal?.teamId !== "null" &&
                      userLocal?.teamId !== null
                        ? appData?.teams?.filter(
                            (e) => e._id === userLocal?.teamId
                          )[0].name
                        : "Sin registrar"}
                    </Link>
                  </div>
                  <div className="user-data-content flex_center_space-between">
                    <p className="title">Email</p>
                    <p className="content">{userLocal?.mail}</p>
                  </div>
                  <div className="user-data-content flex_center_space-between">
                    <p className="title">Puesto</p>
                    <p className="content">{userLocal?.typeOfUser}</p>
                  </div>
                  <div className="user-data-content flex_center_space-between">
                    <p className="title">Suscricpción</p>
                    <p className="content">{userLocal?.plan}</p>
                  </div>
                </>
              )}
            </div>
            <div className="about-user-container">
              <div className="flex_center_space-between">
                <h4>Sobre mi</h4>
              </div>
              <p>Aún nos has cargado una descripción sobre tí</p>
            </div>
            <div className="standing-container">
              <h4>
                {userLocal?.typeOfUser === "Jugador"
                  ? "Porcentaje de tiros"
                  : "Posición a lo largo de la temporada"}
              </h4>
              {dataSets !== null && userLocal?.typeOfUser === "Jugador" ? (
                <Radar
                  data={dataSets !== null ? dataSets : []}
                  options={options}
                />
              ) : dataSets !== null &&
                (userLocal?.typeOfUser === "Entrenador" ||
                  userLocal?.typeOfUser === "owner") ? (
                <Line className="line" options={optionsLine} data={dataSets} />
              ) : null}
            </div>
          </div>
          <div className="container-right">
            <div className="user-app-content">
              <div className="">
                <p>Animaciones realizadas</p>
                <h3>{userLocal?.plays ? userLocal?.plays?.length : 0}</h3>
              </div>
              <div className="">
                <p>Cuentas conectadas</p>
                <h3>
                  {userLocal?.relatedAccounts?.length
                    ? userLocal?.relatedAccounts?.length
                    : 0}
                </h3>
              </div>
            </div>
            <div className="stats-container">
              <div className="stats-container-header">
                {userLocal.typeOfUser === "owner" ||
                userLocal.typeOfUser === "Entrenador" ? (
                  <div className="stats-container-header-buttons">
                    <div
                      className={`chart-option ${
                        selectedChart === "players" ? "active" : null
                      }`}
                      onClick={(e) => {
                        setSelectedChart("players");
                      }}
                    >
                      <p>Jugadores</p>
                    </div>
                    <div
                      className={`chart-option ${
                        selectedChart === "team" ? "active" : null
                      }`}
                      onClick={(e) => {
                        setSelectedChart("team");
                      }}
                    >
                      <p>Equipo</p>
                    </div>
                  </div>
                ) : (
                  <div className="stats-container-header-buttons">
                    <div
                      className={`chart-option ${
                        selectedChart === "games" ? "active" : null
                      }`}
                      onClick={(e) => {
                        setSelectedChart("games");
                      }}
                    >
                      <p>Partidos</p>
                    </div>
                    <div
                      className={`chart-option ${
                        selectedChart === "season" ? "active" : null
                      }`}
                      onClick={(e) => {
                        setSelectedChart("season");
                      }}
                    >
                      <p>Temporada</p>
                    </div>
                  </div>
                )}
                <div className="stats-container-header-data">
                  <div className="stats-container-header-data-extra">
                    <div>
                      <h3>{calculateTeamPosition() + 1}</h3>
                      <p>Posición</p>
                    </div>
                    <div>
                      <h3>
                        {games !== null
                          ? games[0]?.gamesLost + games[0]?.gamesWon
                          : null}
                      </h3>
                      <p>Partidos jugados</p>
                    </div>
                    <div>
                      <h3>{games !== null ? games[0]?.gamesWon : null}</h3>
                      <p>Partidos ganados</p>
                    </div>
                    <div>
                      <h3>{games !== null ? games[0]?.gamesLost : null}</h3>
                      <p>Partidos perdidos</p>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="stats-container-content">
                  {userLocal?.typeOfUser === "Entrenador" ||
                  userLocal?.typeOfUser === "owner" ? (
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">Partido</th>
                          <th scope="col">MINS</th>
                          <th scope="col">PTS</th>
                          <th scope="col">FG</th>
                          <th scope="col">FG%</th>
                          <th scope="col">3P</th>
                          <th scope="col">3P%</th>
                          <th scope="col">FT</th>
                          <th scope="col">FT%</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedChart === "players" &&
                          appData?.players !== null &&
                          teamGames !== null &&
                          appData?.players
                            .filter(
                              (player) =>
                                player.active_team === userLocal?.teamId
                            )
                            .sort((a, b) => a.player_number - b.player_number)
                            .map((player, index) => (
                              <tr>
                                <td>
                                  {`${player.player_name} ${player.player_lastname}`}
                                </td>
                                <td>
                                  {teamGames !== null
                                    ? calculatePlayerStats(
                                        teamGames?.filter(
                                          (game) =>
                                            (game.local_team ===
                                              userLocal?.teamId ||
                                              game.visit_team ===
                                                userLocal?.teamId) &&
                                            game.season ===
                                              process.env
                                                .REACT_APP_ACTIVE_SEASON
                                        ),
                                        player._id,
                                        "MINSP"
                                      )
                                    : 0}
                                </td>
                                <td>
                                  {teamGames !== null
                                    ? calculatePlayerStats(
                                        teamGames?.filter(
                                          (game) =>
                                            (game.local_team ===
                                              userLocal?.teamId ||
                                              game.visit_team ===
                                                userLocal?.teamId) &&
                                            game.season ===
                                              process.env
                                                .REACT_APP_ACTIVE_SEASON
                                        ),
                                        player._id,
                                        "PTS"
                                      )
                                    : 0}
                                </td>
                                <td>
                                  {teamGames !== null
                                    ? calculatePlayerStats(
                                        teamGames?.filter(
                                          (game) =>
                                            (game.local_team ===
                                              userLocal?.teamId ||
                                              game.visit_team ===
                                                userLocal?.teamId) &&
                                            game.season ===
                                              process.env
                                                .REACT_APP_ACTIVE_SEASON
                                        ),
                                        player._id,
                                        "FG"
                                      )
                                    : 0}
                                </td>
                                <td>
                                  {teamGames !== null
                                    ? calculatePlayerStats(
                                        teamGames?.filter(
                                          (game) =>
                                            (game.local_team ===
                                              userLocal?.teamId ||
                                              game.visit_team ===
                                                userLocal?.teamId) &&
                                            game.season ===
                                              process.env
                                                .REACT_APP_ACTIVE_SEASON
                                        ),
                                        player._id,
                                        "FGP"
                                      )
                                    : 0}
                                </td>
                                <td>
                                  {teamGames !== null
                                    ? calculatePlayerStats(
                                        teamGames?.filter(
                                          (game) =>
                                            (game.local_team ===
                                              userLocal?.teamId ||
                                              game.visit_team ===
                                                userLocal?.teamId) &&
                                            game.season ===
                                              process.env
                                                .REACT_APP_ACTIVE_SEASON
                                        ),
                                        player._id,
                                        "THREEP"
                                      )
                                    : 0}
                                </td>
                                <td>
                                  {teamGames !== null
                                    ? calculatePlayerStats(
                                        teamGames?.filter(
                                          (game) =>
                                            (game.local_team ===
                                              userLocal?.teamId ||
                                              game.visit_team ===
                                                userLocal?.teamId) &&
                                            game.season ===
                                              process.env
                                                .REACT_APP_ACTIVE_SEASON
                                        ),
                                        player._id,
                                        "THREEPP"
                                      )
                                    : 0}
                                </td>
                                <td>
                                  {teamGames !== null
                                    ? calculatePlayerStats(
                                        teamGames?.filter(
                                          (game) =>
                                            (game.local_team ===
                                              userLocal?.teamId ||
                                              game.visit_team ===
                                                userLocal?.teamId) &&
                                            game.season ===
                                              process.env
                                                .REACT_APP_ACTIVE_SEASON
                                        ),
                                        player._id,
                                        "FT"
                                      )
                                    : 0}
                                </td>
                                <td>
                                  {teamGames !== null
                                    ? calculatePlayerStats(
                                        teamGames?.filter(
                                          (game) =>
                                            (game.local_team ===
                                              userLocal?.teamId ||
                                              game.visit_team ===
                                                userLocal?.teamId) &&
                                            game.season ===
                                              process.env
                                                .REACT_APP_ACTIVE_SEASON
                                        ),
                                        player._id,
                                        "FTP"
                                      )
                                    : 0}
                                </td>
                              </tr>
                            ))}
                        {selectedChart === "team" ? (
                          <tr>
                            <td>
                              {userLocal?.teamId &&
                              userLocal?.teamId !== "null" &&
                              userLocal?.teamId !== null
                                ? appData?.teams?.filter(
                                    (e) => e._id === userLocal?.teamId
                                  )[0]?.name
                                : "Sin registrar"}
                            </td>
                            <td>
                              {teamGames !== null &&
                                calculatePercj(
                                  teamGames?.filter(
                                    (game) =>
                                      (game.local_team === userLocal?.teamId ||
                                        game.visit_team ===
                                          userLocal?.teamId) &&
                                      game.season ===
                                        process.env.REACT_APP_ACTIVE_SEASON
                                  ),
                                  userLocal?.teamId,
                                  "MINSP"
                                ).toFixed(1)}
                            </td>
                            <td>
                              {teamGames !== null &&
                                calculatePercj(
                                  teamGames?.filter(
                                    (game) =>
                                      (game.local_team === userLocal?.teamId ||
                                        game.visit_team ===
                                          userLocal?.teamId) &&
                                      game.season ===
                                        process.env.REACT_APP_ACTIVE_SEASON
                                  ),
                                  userLocal?.teamId,
                                  "PTS"
                                ).toFixed(1)}
                            </td>
                            <td>
                              {teamGames !== null &&
                                calculatePercj(
                                  teamGames?.filter(
                                    (game) =>
                                      (game.local_team === userLocal?.teamId ||
                                        game.visit_team ===
                                          userLocal?.teamId) &&
                                      game.season ===
                                        process.env.REACT_APP_ACTIVE_SEASON
                                  ),
                                  userLocal?.teamId,
                                  "FG"
                                ).toFixed(1)}
                            </td>
                            <td>
                              {teamGames !== null &&
                                calculatePercj(
                                  teamGames?.filter(
                                    (game) =>
                                      (game.local_team === userLocal?.teamId ||
                                        game.visit_team ===
                                          userLocal?.teamId) &&
                                      game.season ===
                                        process.env.REACT_APP_ACTIVE_SEASON
                                  ),
                                  userLocal?.teamId,
                                  "FGP"
                                ).toFixed(1)}
                            </td>
                            <td>
                              {teamGames !== null &&
                                calculatePercj(
                                  teamGames?.filter(
                                    (game) =>
                                      (game.local_team === userLocal?.teamId ||
                                        game.visit_team ===
                                          userLocal?.teamId) &&
                                      game.season ===
                                        process.env.REACT_APP_ACTIVE_SEASON
                                  ),
                                  userLocal?.teamId,
                                  "THREEP"
                                ).toFixed(1)}
                            </td>
                            <td>
                              {teamGames !== null &&
                                calculatePercj(
                                  teamGames?.filter(
                                    (game) =>
                                      (game.local_team === userLocal?.teamId ||
                                        game.visit_team ===
                                          userLocal?.teamId) &&
                                      game.season ===
                                        process.env.REACT_APP_ACTIVE_SEASON
                                  ),
                                  userLocal?.teamId,
                                  "THREEPP"
                                ).toFixed(1)}
                            </td>
                            <td>
                              {teamGames !== null &&
                                calculatePercj(
                                  teamGames?.filter(
                                    (game) =>
                                      (game.local_team === userLocal?.teamId ||
                                        game.visit_team ===
                                          userLocal?.teamId) &&
                                      game.season ===
                                        process.env.REACT_APP_ACTIVE_SEASON
                                  ),
                                  userLocal?.teamId,
                                  "FT"
                                ).toFixed(1)}
                            </td>
                            <td>
                              {teamGames !== null &&
                                calculatePercj(
                                  teamGames?.filter(
                                    (game) =>
                                      (game.local_team === userLocal?.teamId ||
                                        game.visit_team ===
                                          userLocal?.teamId) &&
                                      game.season ===
                                        process.env.REACT_APP_ACTIVE_SEASON
                                  ),
                                  userLocal?.teamId,
                                  "FTP"
                                ).toFixed(1)}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  ) : userLocal?.typeOfUser === "Jugador" ? (
                    <table className="player-view">
                      <thead>
                        <tr>
                          <th scope="col">Partido</th>
                          <th scope="col">MINS</th>
                          <th scope="col">PTS</th>
                          <th scope="col">2P</th>
                          <th scope="col">2P%</th>
                          <th scope="col">3P</th>
                          <th scope="col">3P%</th>
                          <th scope="col">FT</th>
                          <th scope="col">FT%</th>
                        </tr>
                      </thead>
                      {selectedChart === "games" ? (
                        <tbody>
                          {appData?.players !== null &&
                            teamGames !== null &&
                            teamGames
                              .filter(
                                (game) =>
                                  (game.local_team === userLocal?.teamId ||
                                    game.visit_team === userLocal?.teamId) &&
                                  game.season ===
                                    process.env.REACT_APP_ACTIVE_SEASON
                              )
                              .sort(
                                (a, b) =>
                                  unformatDate(b.date) - unformatDate(a.date)
                              )
                              .map((game, index) => (
                                <tr>
                                  <td>
                                    <span
                                      className={
                                        game.local_team === userLocal?.teamId
                                          ? "black"
                                          : null
                                      }
                                    >
                                      {
                                        appData?.teams.filter(
                                          (team) => team._id === game.local_team
                                        )[0].name
                                      }{" "}
                                    </span>
                                    vs{" "}
                                    <span
                                      className={
                                        game.visit_team === userLocal?.teamId
                                          ? "black"
                                          : null
                                      }
                                    >
                                      {
                                        appData?.teams.filter(
                                          (team) => team._id === game.visit_team
                                        )[0].name
                                      }
                                    </span>
                                  </td>
                                  <td>
                                    {game?.local_team === userLocal?.teamId
                                      ? game.local_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]?.mins
                                      : game.visit_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]?.mins}
                                  </td>
                                  <td>
                                    {game?.local_team === userLocal?.teamId
                                      ? game.local_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]?.pts
                                      : game.visit_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]?.pts}
                                  </td>

                                  <td>
                                    {game?.local_team === userLocal?.teamId &&
                                    game.local_stats.filter(
                                      (stat) => stat.player_id === userLocal?.id
                                    ).length > 0
                                      ? game.local_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]["2pA/I"]
                                      : game?.visit_team ===
                                          userLocal?.teamId &&
                                        game.visit_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        ).length > 0
                                      ? game.visit_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]["2pA/I"]
                                      : "Unknown"}
                                  </td>
                                  <td>
                                    {game?.local_team === userLocal?.teamId &&
                                    game.local_stats.filter(
                                      (stat) => stat.player_id === userLocal?.id
                                    ).length > 0
                                      ? game.local_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]["2pPcj"]
                                      : game?.visit_team ===
                                          userLocal?.teamId &&
                                        game.visit_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        ).length > 0
                                      ? game.visit_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]["2pPcj"]
                                      : "Unknown"}
                                  </td>
                                  <td>
                                    {game?.local_team === userLocal?.teamId &&
                                    game.local_stats.filter(
                                      (stat) => stat.player_id === userLocal?.id
                                    ).length > 0
                                      ? game.local_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]["3pA/I"]
                                      : game?.visit_team ===
                                          userLocal?.teamId &&
                                        game.visit_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        ).length > 0
                                      ? game.visit_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]["3pA/I"]
                                      : "Unknown"}
                                  </td>
                                  <td>
                                    {game?.local_team === userLocal?.teamId &&
                                    game.local_stats.filter(
                                      (stat) => stat.player_id === userLocal?.id
                                    ).length > 0
                                      ? game.local_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]["3pPcj"]
                                      : game?.visit_team ===
                                          userLocal?.teamId &&
                                        game.visit_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        ).length > 0
                                      ? game.visit_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]["3pPcj"]
                                      : "Unknown"}
                                  </td>
                                  <td>
                                    {game?.local_team === userLocal?.teamId &&
                                    game.local_stats.filter(
                                      (stat) => stat.player_id === userLocal?.id
                                    ).length > 0
                                      ? game.local_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]["tlA/I"]
                                      : game?.visit_team ===
                                          userLocal?.teamId &&
                                        game.visit_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        ).length > 0
                                      ? game.visit_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]["tlA/I"]
                                      : "Unknown"}
                                  </td>
                                  <td>
                                    {game?.local_team === userLocal?.teamId &&
                                    game.local_stats.filter(
                                      (stat) => stat.player_id === userLocal?.id
                                    ).length > 0
                                      ? game.local_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]["tlPcj"]
                                      : game?.visit_team ===
                                          userLocal?.teamId &&
                                        game.visit_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        ).length > 0
                                      ? game.visit_stats.filter(
                                          (stat) =>
                                            stat.player_id === userLocal?.id
                                        )[0]["tlPcj"]
                                      : "Unknown"}
                                  </td>
                                </tr>
                              ))}
                        </tbody>
                      ) : selectedChart === "season" ? (
                        <tbody>
                          {appData?.players !== null &&
                            teamGames !== null &&
                            Object.values(activeSeasons).map(
                              (season, index) => (
                                <tr>
                                  <td>{userLocal.name}</td>
                                  <td>
                                    {calculatePlayerStats(
                                      teamGames?.filter(
                                        (game) =>
                                          (game.local_team ===
                                            userLocal?.teamId ||
                                            game.visit_team ===
                                              userLocal?.teamId) &&
                                          game.season ===
                                            process.env.REACT_APP_ACTIVE_SEASON
                                      ),
                                      userLocal.id,
                                      "MINSP"
                                    )}
                                  </td>
                                  <td>
                                    {calculatePlayerStats(
                                      teamGames?.filter(
                                        (game) =>
                                          (game.local_team ===
                                            userLocal?.teamId ||
                                            game.visit_team ===
                                              userLocal?.teamId) &&
                                          game.season ===
                                            process.env.REACT_APP_ACTIVE_SEASON
                                      ),
                                      userLocal.id,
                                      "PTS"
                                    )}
                                  </td>
                                  <td>
                                    {calculatePlayerStats(
                                      teamGames?.filter(
                                        (game) =>
                                          (game.local_team ===
                                            userLocal?.teamId ||
                                            game.visit_team ===
                                              userLocal?.teamId) &&
                                          game.season ===
                                            process.env.REACT_APP_ACTIVE_SEASON
                                      ),
                                      userLocal.id,
                                      "TWOOP"
                                    )}
                                  </td>
                                  <td>
                                    {calculatePlayerStats(
                                      teamGames?.filter(
                                        (game) =>
                                          (game.local_team ===
                                            userLocal?.teamId ||
                                            game.visit_team ===
                                              userLocal?.teamId) &&
                                          game.season ===
                                            process.env.REACT_APP_ACTIVE_SEASON
                                      ),
                                      userLocal.id,
                                      "TWOOPP"
                                    )}
                                  </td>
                                  <td>
                                    {calculatePlayerStats(
                                      teamGames?.filter(
                                        (game) =>
                                          (game.local_team ===
                                            userLocal?.teamId ||
                                            game.visit_team ===
                                              userLocal?.teamId) &&
                                          game.season ===
                                            process.env.REACT_APP_ACTIVE_SEASON
                                      ),
                                      userLocal.id,
                                      "THREEP"
                                    )}
                                  </td>
                                  <td>
                                    {calculatePlayerStats(
                                      teamGames?.filter(
                                        (game) =>
                                          (game.local_team ===
                                            userLocal?.teamId ||
                                            game.visit_team ===
                                              userLocal?.teamId) &&
                                          game.season ===
                                            process.env.REACT_APP_ACTIVE_SEASON
                                      ),
                                      userLocal.id,
                                      "THREEPP"
                                    )}
                                  </td>
                                  <td>
                                    {calculatePlayerStats(
                                      teamGames?.filter(
                                        (game) =>
                                          (game.local_team ===
                                            userLocal?.teamId ||
                                            game.visit_team ===
                                              userLocal?.teamId) &&
                                          game.season ===
                                            process.env.REACT_APP_ACTIVE_SEASON
                                      ),
                                      userLocal.id,
                                      "FT"
                                    )}
                                  </td>
                                  <td>
                                    {calculatePlayerStats(
                                      teamGames?.filter(
                                        (game) =>
                                          (game.local_team ===
                                            userLocal?.teamId ||
                                            game.visit_team ===
                                              userLocal?.teamId) &&
                                          game.season ===
                                            process.env.REACT_APP_ACTIVE_SEASON
                                      ),
                                      userLocal.id,
                                      "FTP"
                                    )}
                                  </td>
                                </tr>
                              )
                            )}
                        </tbody>
                      ) : null}
                    </table>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Layout>
  );
}
